import { Business } from './icons/Business'
import { UserCircle } from './icons/UserCircle'

export function HeaderAccount({
  handleClick,
  activeMenuItem,
}: Readonly<HeaderAccountProps>) {
  return (
    <header className="container border-[0.07rem] border-neutral-100 dark:border-neutral-700 h-20 shadow-lg rounded-3xl md:rounded-full mt-5 md:mt-12 flex dark:bg-neutral-900 justify-between mx-auto items-center">
      <nav className="flex items-center mx-auto justify-evenly md:justify-center w-full gap-1 md:gap-8">
        <li className="list-none flex border-2 border-transparent h-20 relative items-center">
          <button
            className="dark:text-white p-1 md:p-4 cursor-pointer flex flex-col items-center"
            onClick={() => handleClick(0)}
          >
            <Business
              className="w-8 h-8 mb-1 md:mb-auto"
              color={activeMenuItem === 0 ? '#4F46E5' : 'currentColor'}
            />
            <p
              className={`${
                activeMenuItem === 0
                  ? 'text-[#4F46E5]'
                  : 'text-neutral-700 dark:text-neutral-400'
              } text-xs md:text-base`}
            >
              Empresa
            </p>
            <div
              className={`
                absolute -bottom-1 left-0 w-full h-[0.1rem] md:h-1
                rounded bg-[#4F46E5]
                ${
                  activeMenuItem === 0
                    ? 'transition-all ease-in-out duration-500'
                    : 'hidden'
                }
              `}
            ></div>
          </button>
        </li>
        <li className="list-none flex border-2 border-transparent h-20 relative items-center">
          <button
            className="dark:text-white p-1 md:p-4 cursor-pointer flex flex-col items-center"
            onClick={() => handleClick(1)}
          >
            <UserCircle
              className="w-8 h-8 mb-1 md:mb-auto"
              color={activeMenuItem === 1 ? '#4F46E5' : 'currentColor'}
            />
            <p
              className={`${
                activeMenuItem === 1
                  ? 'text-[#4F46E5]'
                  : 'text-neutral-700 dark:text-neutral-400'
              } text-xs md:text-base`}
            >
              Usuários
            </p>
            <div
              className={`
                absolute -bottom-1 left-0 w-full h-[0.1rem] md:h-1
                rounded bg-[#4F46E5] ${activeMenuItem === 1 ? '' : 'hidden'}
              `}
            ></div>
          </button>
        </li>
      </nav>
    </header>
  )
}
